import React from 'react';

import Grid from '../../Grid';

const SectionRow: React.FC = ({ children }) => (
  <Grid container spacing={2}>
    {children}
  </Grid>
);

export default SectionRow;
